<p-dialog
  header="ERA SME Notification"
  [modal]="true"
  [(visible)]="visible"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '48rem' }"
  styleClass="sme-notification-dialog"
  (onHide)="close()">

  <p-messages></p-messages>

  <div class="notification-form">
    <div class="field-group">
      <label for="sme-recipients">Send to</label>
      <p-autoComplete
        inputId="sme-recipients"
        placeholder="Add SME recipients"
        [(ngModel)]="selectedRecipients"
        [suggestions]="suggestions"
        [multiple]="true"
        [minLength]="2"
        [delay]="300"
        field="displayName"
        (completeMethod)="searchUsers($event)">
        <ng-template let-user pTemplate="item">
          <div class="sme-user-option">
            <span class="sme-user-name">{{ user.displayName }}</span>
            <span class="sme-user-mail">{{ user.mail }}</span>
          </div>
        </ng-template>
      </p-autoComplete>
    </div>

    <div class="field-group">
      <label for="sme-notes">Notes</label>
      <textarea
        id="sme-notes"
        rows="5"
        pInputTextarea
        [(ngModel)]="notes"
        [autoResize]="true"
        placeholder="Add a note for the SME review..."></textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="sme-footer">
      <div class="sme-status-section">
        <label>PECs Signed Off</label>
        <div class="sme-status-row">
          <div *ngFor="let step of stepStatuses"
               class="sme-status-item"
               [class.sme-status-on]="step.selected && !step.errorMessage"
               [class.sme-status-off]="!step.selected && !step.errorMessage"
               [class.sme-status-error]="!!step.errorMessage"
               [pTooltip]="step.errorMessage || ''"
               [tooltipDisabled]="!step.errorMessage"
               tooltipPosition="top">
            <i class="pi"
               [ngClass]="step.errorMessage ? 'pi-exclamation-circle' : (step.selected ? 'pi-check-circle' : 'pi-circle')"></i>
            <span>{{ step.label }}</span>
          </div>
        </div>
      </div>
      <button
        pButton
        type="button"
        [label]="sending ? 'Sending...' : 'Send'"
        [icon]="sending ? 'pi pi-spin pi-spinner' : 'pi pi-send'"
        [disabled]="isSendDisabled"
        (click)="send()"></button>
    </div>
  </ng-template>
</p-dialog>
